import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AtributoValorEntity, MapeamentoAtributosEntity } from '@catalogo/models';
import { AtributoReceitaEntity } from '@catalogo/models/atributo-receita.entity';
import { CONFIGURACAO_API_URL, OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class MapeamentoAtributosDataService extends CrudService<MapeamentoAtributosEntity> {
  protected url: string;
  protected urlConfiguracao: string;

  constructor(
    @Inject(OPERACAO_API_URL) urlBase: string,
    @Inject(CONFIGURACAO_API_URL) urlConfiguracao: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(urlBase, httpClient);
    this.url = `${urlBase}/v1/mapeamentoatributo`;
    this.urlConfiguracao = `${urlConfiguracao}/v1/atributoreceita`;
  }
  
  //Todo: analisar local mais apropriado para estas chamadas
  public obterAtributosPorNcmId(ncmId: string) {
    let urlAtributoNcm = `${this.urlConfiguracao}/Ncm/${ncmId}`

    return this.httpClient.get<AtributoReceitaEntity>(urlAtributoNcm) ;   
  }

  public obterAtributosReceitaDominio(atributoId: string) {
    let urlAtributoDominios = `${this.urlConfiguracao}/${atributoId}/dominios`

    return this.httpClient.get<AtributoReceitaEntity>(urlAtributoDominios) ;   
  }

  public obterAtributosValores(pdmAtributoId: string) {
    let urlAtributosValores = `${this.urlBase}/v1/pdm/versao/${pdmAtributoId}/atributovalores`;

    return this.httpClient.get<AtributoValorEntity>(urlAtributosValores);
  }
}
